import { useQuery } from '@tanstack/react-query';
import {
  fetchListaDocumentosItensSimples,
  type ListaItensSimplesFiltro,
} from '../api/ListaDocumentosItensSimplesApi';

export function useListaDocumentosItensSimples(filtro: ListaItensSimplesFiltro, enabled: boolean) {
  return useQuery({
    queryKey: ['lista-documentos-itens-simples', filtro],
    queryFn: () => fetchListaDocumentosItensSimples(filtro),
    enabled,
    staleTime: 30_000,
  });
}
